var _path, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLichidare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4836 7.09157L10.5278 29.5998",
    stroke: "#B70020",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.98047,
    y: 7.0918,
    width: 8.325,
    height: 9.25,
    rx: 4.1625,
    stroke: "url(#paint0_linear_23833_410651)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0898,
    y: 20.3496,
    width: 8.325,
    height: 9.25,
    rx: 4.1625,
    stroke: "url(#paint1_linear_23833_410651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23833_410651",
    x1: 15.3564,
    y1: 9.16833,
    x2: 6.71929,
    y2: 9.85791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA0029"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23833_410651",
    x1: 30.4658,
    y1: 22.4261,
    x2: 21.8287,
    y2: 23.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA0029"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLichidare);
export default __webpack_public_path__ + "static/media/lichidare.f069bb74.svg";
export { ForwardRef as ReactComponent };